import UserInfo from '../../../Sidebar/UserInfo'
import UserInformation from './UserInformation'
export default UserInformation
